import React, { useState, useEffect } from 'react';
import { ValidatorForm } from 'react-form-validator-core';
import { useHistory } from 'react-router-dom';

import { Input, Button } from '../../Atoms';
import { ErrorIcon, Logo } from '../../Assets';

import '../Login/login.scss';
import { passwordReset } from '../../redux/actions/AuthenticationAction';
import { connect } from 'react-redux';
import useToaster from '../../components/Toaster/useToaster';

const ForgotPassword = ({
  resetPassword,
  reset: { loading, success, error },
}) => {
  const { toast } = useToaster();
  const history = useHistory();
  const [formData, setFormData] = useState({ email: '' });
  const handleSubmit = () => {
    const host = window.location.origin;
    resetPassword({ email: formData.email, reset_url: `${host}/verify` });
  };

  const handleChange = ({ target: { name, value } }) => {
    setFormData({ ...formData, [name]: value });
  };

  const handleClear = () => {
    setFormData({ email: '' });
    history.push('/login');
  };

  useEffect(() => {
    if (success) {
      toast({
        text: 'Your request has been accepted, please check your email.',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  return (
    <div className="login-wrapper">
      <div className="login-form">
        <Logo />
        <div className="heading">Forgot Password</div>
        <div className="forgot-info">
          Tell us your email address and we will send you an email so that you
          may reset your password.
        </div>
        {error && (
          <div className="error-wrapper">
            <div>
              <ErrorIcon />
            </div>
            <span>{error}</span>
          </div>
        )}
        <ValidatorForm onSubmit={handleSubmit} className="form">
          <Input
            onChange={handleChange}
            value={formData.email}
            title="Email Address"
            placeholder="Email Address"
            name="email"
            validators={['required', 'isEmail']}
            errorMessages={['this field is required', 'email is not valid']}
            formValid={!error}
          />
          <div className="action-btn">
            <Button type="button" size="sm" color="grey" onClick={handleClear}>
              Cancel
            </Button>
            <Button type="submit" size="sm" color="blue" loading={loading}>
              Send EMail
            </Button>
          </div>
        </ValidatorForm>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  reset: state.auth.resetPassword,
});

const mapDispatchToProps = (dispatch) => ({
  resetPassword: (details) => {
    dispatch(passwordReset(details));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
